// Global styles — order matters: tokens → fonts → reset → components → app-level.
import '@schwrz/shared/tokens.css';
import './styles/fonts.css';
import '@schwrz/shared/reset.css';
import '@schwrz/shared/components.css';
import './styles/global.css';

import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import { i18n } from './locales/index.js';
import { router } from './router/index.js';

// Apply the persisted theme before first paint so the login screen matches the
// user's choice (ThemeToggle itself only mounts inside the authenticated shell).
try {
  if (localStorage.getItem('tm-theme') === 'light') {
    document.documentElement.setAttribute('data-theme', 'light');
  }
} catch {
  /* localStorage unavailable (private mode) — default dark */
}

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(i18n);
app.mount('#app');
